export default "__VITE_ASSET__26c46ac9__"